<template>
  <section>
    <div class="mui-content pd-8">
      <div class="title-name">
        <span class="">修改密码</span>
      </div>
      <div class="sampling-first" style="border-bottom: 0px;margin-top: 20%;">
        <div style="padding-top: 10px;position: relative">
          <div class="form-group">
            <div class="input-label">
              <label>原密码：</label>
            </div>
            <div class="form-input">
              <input type="password" v-model="oldpwd" maxlength="10" placeholder="原密码"/>
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>新密码：</label>
            </div>
            <div class="form-input">
              <input type="password" v-model="newpwd" maxlength="10" placeholder="密码不小于8位"/>
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>确认密码：</label>
            </div>
            <div class="form-input">
              <input type="password" v-model="conpwd" maxlength="10" placeholder="密码不小于8位"/>
            </div>
          </div>
          <div class="form-group" style="width:100%;margin-top: 10px;margin-bottom: 10px;">
            <button type="button" class="mui-btn mui-btn-primary btn-blue" style="margin: auto;width: 80px;" @tap="save">完成</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "chPwd",
  data() {
    return {
      oldpwd: "",
      newpwd: "",
      conpwd: ""
    }
  },
  created() {
  },
  activated() {
    var v = this;
    v.oldpwd = "";
    v.newpwd = "";
    v.conpwd = "";
  },
  methods: {
    save() {
      var v = this;
      if(v.oldpwd == ""){
        mui.toast("请输入原密码");
        return;
      }
      if(v.newpwd == ""){
        mui.toast("请输入新密码");
        return;
      }
      if(v.newpwd.length < 8){
        mui.toast("密码长度不得小于8位");
        return;
      }
      if(v.conpwd == ""){
        mui.toast("请输入确认密码");
        return;
      }
      if(v.conpwd.length < 8){
        mui.toast("密码长度不得小于8位");
        return;
      }
      v.nyy.doPost("/Main/chgPwd", {
        "oldpwd": v.oldpwd,
        "newpwd": v.newpwd,
        "conpwd": v.conpwd
      },
        function(result) {
          if (result.status) {
            mui.alert("密码修改成功","消息提示",function(){
              wx.closeWindow();
            });
          } else {
            mui.toast(result.message);
          }
        }
      );
    }
  }
}
</script>
<style scoped>
@import "../../static/css/sampling.css";
@import "../../static/css/samplinghistory.css";
@import "../../static/css/filterorder.css";
@import "../../static/css/quality.css";
</style>



// WEBPACK FOOTER //
// src/components/chgPwd.vue